import { render } from "./PaginatedTransactions.vue?vue&type=template&id=43abe11a"
import script from "./PaginatedTransactions.vue?vue&type=script&lang=ts"
export * from "./PaginatedTransactions.vue?vue&type=script&lang=ts"
script.render = render

export default script